import { render, staticRenderFns } from "./EditAct.vue?vue&type=template&id=0b6da528&scoped=true&"
import script from "./EditAct.vue?vue&type=script&lang=js&"
export * from "./EditAct.vue?vue&type=script&lang=js&"
import style0 from "./EditAct.vue?vue&type=style&index=0&id=0b6da528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6da528",
  null
  
)

export default component.exports